<template>
  <div class="form_field flex_field border-bottom align-items-start">
    <div class="label_container_date">
      <div class="date">
        <label for="">Quotazione richiesta al (mese/anno)</label>
      </div>
      <div class="text_container">
        <p>Fino a un massimo di 10 anni dalla data di immatricolazione inserita</p>
      </div>
    </div>
    <div class="label_container_date">
      <div class="form-group">
        <custom-select
          :options="anniOptions"
          placeholder="Anno"
          name="anno"
          required
          v-model="selected.anni"
          :isOpen="openDropdown === 0"
          @toggle="handleToggle(0)"
        ></custom-select>
        <custom-select
          :options="mesiOptions"
          placeholder="Mese"
          name="mese"
          required
          v-model="selected.mesi"
          :isOpen="openDropdown === 1"
          @toggle="handleToggle(1)"
        ></custom-select>
      </div>
    </div>
  </div>
</template>

<script>
import CustomSelect from './CustomSelect.vue';
export default {
  name: 'FormFieldDate',
  components: {
    CustomSelect,
  },
  props: {
    anni: {
      type: Object,
      required: true,
    },
    mesi: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      options: {
        anni: {},
        mesi: {},
      },
      selected: {
        anni: '',
        mesi: '',
      },
      openDropdown: null,
    };
  },
  computed: {
    anniOptions() {
      return Object.keys(this.anni).map(key => ({
        value: key,
        text: this.anni[key],
      }));
    },
    mesiOptions() {
      if (this.selected.anni && this.mesi[this.selected.anni]) {
        return Object.keys(this.mesi[this.selected.anni]).map(key => ({
          value: key,
          text: this.mesi[this.selected.anni][key],
        }));
      }
      return [];
    },
    isValid() {
      return this.selected.anni !== '' && this.selected.mesi !== '';
    },
  },
  watch: {
    selected: {
      deep: true,
      handler() {
        this.$emit('validation', this.isValid);
      },
    },
  },
  methods: {
    handleToggle(index) {
      if (this.openDropdown === index) {
        this.openDropdown = null;
      } else {
        this.openDropdown = index;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/js/app/components/FormFieldDate.vue